// extracted by mini-css-extract-plugin
module.exports = {"box":"_1dPf5","root":"_2xEue","divider":"_3DXYQ"};